export const NUMBER_STEPS = 5

export const BIOMETRY_SIMILARITY_THRESHOLD = 50

export const STEPS = [
  "Cliente",
  "Endereço",
  "Biometria",
  "Produtos",
  "Fatura",
  "Resumo"
]

export const STEP_NAME_ROUTES = [
  "",
  "audit-client",
  "audit-address",
  "audit-biometry",
  "audit-product",
  "audit-billing",
  "audit-summary"
]

export const ROUTES_ANALYZE_COVERAGE = [
  "audit-analyze-coverage-client",
  "audit-analyze-coverage-address"
]

export const STEPS_ANALYZE_COVERAGE = [
  "Cliente",
  "Endereço"
]

export const PENDENCY_TYPES = [
  {
    status: "Pendente Vendedor",
    status_id: 4,
    notes: [
      {
        note_type_id: 1,
        note_type_description: "Correção de dados cadastrais"
      }
    ]
  },
  {
    status: "Pendente Agendamento",
    status_id: 8,
    notes: [
      {
        note_type_id: 4,
        note_type_description: "Agendar instalação."
      }
    ]
  },
  {
    status: "Pendente Sistema",
    status_id: 7,
    notes: [
      {
        note_type_id: 3,
        note_type_description: "Sistema indisponível - Favor aguardar"
      }
    ]
  },
  {
    status: "Pendente BKO",
    status_id: 6,
    notes: [{ note_type_id: 2, note_type_description: "Cliente não atende" }]
  }
]

export const SERVICE_STATUS = [
  { text: "Aguardando", value: 1 },
  { text: "Aprovado", value: 2 },
  { text: "Reprovado", value: 3 },
  { text: "Desistência", value: 4 },
  { text: "Cancelado", value: 5 },
  { text: "Removido", value: 6 }
]

export const SERVICE_STATUS_NAME = {
  awaiting: "Aguardando",
  approved: "Aprovado",
  reproved: "Reprovado",
  withdrawal: "Desistência",
  canceled: "Cancelado",
  removed: "Removido"
}

export const SERVICE_STATUS_VALUE = {
  awaiting: 1,
  approved: 2,
  reproved: 3,
  withdrawal: 4,
  canceled: 5,
  removed: 6
}

export const ADDRESS_COMPLEMENT_TYPES = [
  { value: 1, text: "AL - Altos" },
  { value: 2, text: "AN - Andar" },
  { value: 3, text: "AP - Apartamento" },
  { value: 4, text: "AR - Armazém" },
  { value: 5, text: "ARC - Arco" },
  { value: 6, text: "AT - Altura" },
  { value: 7, text: "BE - Beco" },
  { value: 8, text: "BL - Blocos" },
  { value: 9, text: "BO - Box" },
  { value: 10, text: "BX - Baixos" },
  { value: 11, text: "CA - Cais" },
  { value: 12, text: "CB - Cobertura" },
  { value: 13, text: "CD - Condomínio" },
  { value: 14, text: "CH - Chácara" },
  { value: 15, text: "CJ - Conjunto" },
  { value: 16, text: "CR - Corredor" },
  { value: 17, text: "CS - Casa" },
  { value: 18, text: "CX - Caixa Postal" },
  { value: 19, text: "ED - Edifício" },
  { value: 20, text: "EN - Entrada" },
  { value: 21, text: "EP - Entrepiso" },
  { value: 22, text: "FAZ - Fazenda" },
  { value: 23, text: "FR - Frente" },
  { value: 24, text: "FU - Fundos" },
  { value: 25, text: "GI - Guichê" },
  { value: 26, text: "GJ - Granja" },
  { value: 27, text: "GL - Galeria" },
  { value: 28, text: "GR - Garagem" },
  { value: 29, text: "HG - Hangar" },
  { value: 30, text: "KM - Quilômetro" },
  { value: 31, text: "LA - Lado" },
  { value: 32, text: "LE - Letra" },
  { value: 33, text: "LJ - Loja" },
  { value: 34, text: "LOT - Loteamento" },
  { value: 35, text: "LT - Lote" },
  { value: 36, text: "MZ - Mezanino" },
  { value: 37, text: "PA - Pavimento" },
  { value: 38, text: "PD - Prédio" },
  { value: 39, text: "PE - Poste" },
  { value: 40, text: "PI - Piso" },
  { value: 41, text: "PL - Plataforma" },
  { value: 42, text: "PO - Portão" },
  { value: 43, text: "PR - Parada" },
  { value: 44, text: "PT - Ponte" },
  { value: 45, text: "PV - Pavilhão" },
  { value: 46, text: "PX - Próximo" },
  { value: 47, text: "QD - Quadra" },
  { value: 48, text: "REC - Recanto" },
  { value: 49, text: "SG - Saguão" },
  { value: 50, text: "SIT - Sítio" },
  { value: 51, text: "SJ - Sobreloja" },
  { value: 52, text: "SL - Sala" },
  { value: 53, text: "SOB - Sobrado" },
  { value: 54, text: "SS - Sub-solo" },
  { value: 55, text: "TR - Térreo" },
  { value: 56, text: "ZN - Zona" }
]

export const STATES = [
  { value: 0, text: "Selecione...", acronym: "" },
  { value: 1, text: "Acre", acronym: "AC" },
  { value: 2, text: "Alagoas", acronym: "AL" },
  { value: 3, text: "Amazonas", acronym: "AM" },
  { value: 4, text: "Amapá", acronym: "AP" },
  { value: 5, text: "Bahia", acronym: "BA" },
  { value: 6, text: "Ceará", acronym: "CE" },
  { value: 7, text: "Distrito Federal", acronym: "DF" },
  { value: 8, text: "Espírito Santo", acronym: "ES" },
  { value: 9, text: "Goiás", acronym: "GO" },
  { value: 10, text: "Maranhão", acronym: "MA" },
  { value: 11, text: "Minas Gerais", acronym: "MG" },
  { value: 12, text: "Mato Grosso do Sul", acronym: "MS" },
  { value: 13, text: "Mato Grosso", acronym: "MT" },
  { value: 14, text: "Pará", acronym: "PA" },
  { value: 15, text: "Paraíba", acronym: "PB" },
  { value: 16, text: "Pernambuco", acronym: "PE" },
  { value: 17, text: "Piauí", acronym: "PI" },
  { value: 18, text: "Paraná", acronym: "PR" },
  { value: 19, text: "Rio de Janeiro", acronym: "RJ" },
  { value: 20, text: "Rio Grande do Norte", acronym: "RN" },
  { value: 21, text: "Rondônia", acronym: "RO" },
  { value: 22, text: "Roraima", acronym: "RR" },
  { value: 23, text: "Rio Grande do Sul", acronym: "RS" },
  { value: 24, text: "Santa Catarina", acronym: "SC" },
  { value: 25, text: "Sergipe", acronym: "SE" },
  { value: 26, text: "São Paulo", acronym: "SP" },
  { value: 27, text: "Tocantins", acronym: "TO" }
]

export const CORPORATE_TYPE_OPTIONS = [
  { value: 1, text: "Empresa LTDA" },
  { value: 2, text: "Sociedade Anônima" },
  { value: 3, text: "Sindicatos, Cooperativas e Associações" },
  { value: 4, text: "Firma Individual" },
  { value: 5, text: "Igrejas" },
  { value: 6, text: "Condomínio" },
  { value: 7, text: "Produtor Rural" }
]

export const STATE_REGISTRATION_MASK = [
  {
    idState: 0,
    textState: "Selecione",
    mask: null,
    placeHolder: "Inscrição Estadual",
    maxLength: 0,
    minLengthClean: 0
  },
  {
    idState: 1,
    textState: "Acre",
    mask: ["##.###.###/###-##"],
    placeHolder: "__.___.___/___-__",
    maxLength: 17,
    minLengthClean: 13
  },
  {
    idState: 2,
    textState: "Alagoas",
    mask: ["#########"],
    placeHolder: "_________",
    maxLength: 9,
    minLengthClean: 9
  },
  {
    idState: 3,
    textState: "Amazonas",
    mask: ["##.###.###-#"],
    placeHolder: "__.___.___-_",
    maxLength: 12,
    minLengthClean: 9
  },
  {
    idState: 4,
    textState: "Amapá",
    mask: ["#########"],
    placeHolder: "_________",
    maxLength: 9,
    minLengthClean: 9
  },
  {
    idState: 5,
    textState: "Bahia",
    mask: ["######-##"],
    placeHolder: "______-__",
    maxLength: 9,
    minLengthClean: 8
  },
  {
    idState: 6,
    textState: "Ceará",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 7,
    textState: "Distrito Federal",
    mask: ["###########-##"],
    placeHolder: "___________-__",
    maxLength: 14,
    minLengthClean: 13
  },
  {
    idState: 8,
    textState: "Espírito Santo",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 9,
    textState: "Goiás",
    mask: ["##.###.###-#"],
    placeHolder: "__.___.___-_",
    maxLength: 12,
    minLengthClean: 9
  },
  {
    idState: 10,
    textState: "Maranhão",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 11,
    textState: "Minas Gerais",
    mask: ["###.###.###/####"],
    placeHolder: "___.___.___/____",
    maxLength: 16,
    minLengthClean: 13
  },
  {
    idState: 12,
    textState: "Mato Grosso do Sul",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 13,
    textState: "Mato Grosso",
    mask: ["##########-#"],
    placeHolder: "__________-_",
    maxLength: 16,
    minLengthClean: 13
  },
  {
    idState: 14,
    textState: "Pará",
    mask: ["##-######-#"],
    placeHolder: "__-______-_",
    maxLength: 11,
    minLengthClean: 9
  },
  {
    idState: 15,
    textState: "Paraíba",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 16,
    textState: "Pernambuco",
    mask: ["#######-##"],
    placeHolder: "_______-__",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 17,
    textState: "Piauí",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 18,
    textState: "Paraná",
    mask: ["###.#####-##"],
    placeHolder: "___._____-__",
    maxLength: 12,
    minLengthClean: 10
  },
  {
    idState: 19,
    textState: "Rio de Janeiro",
    mask: ["##.###.##-#"],
    placeHolder: "__.___.__-_",
    maxLength: 11,
    minLengthClean: 8
  },
  {
    idState: 20,
    textState: "Rio Grande do Norte",
    mask: ["##.###.###-#"],
    placeHolder: "__.___.___._",
    maxLength: 12,
    minLengthClean: 9
  },
  {
    idState: 21,
    textState: "Rondônia",
    mask: ["#############-#"],
    placeHolder: "_____________-_",
    maxLength: 15,
    minLengthClean: 14
  },
  {
    idState: 22,
    textState: "Roraima",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 23,
    textState: "Rio Grande do Sul",
    mask: ["###/#######"],
    placeHolder: "___/_______",
    maxLength: 11,
    minLengthClean: 10
  },
  {
    idState: 24,
    textState: "Santa Catarina",
    mask: ["###.###.###"],
    placeHolder: "___.___.___",
    maxLength: 11,
    minLengthClean: 9
  },
  {
    idState: 25,
    textState: "Sergipe",
    mask: ["########-#"],
    placeHolder: "________-_",
    maxLength: 10,
    minLengthClean: 9
  },
  {
    idState: 26,
    textState: "São Paulo",
    mask: ["###.###.###.###"],
    placeHolder: "___.___.___.___",
    maxLength: 15,
    minLengthClean: 12
  },
  {
    idState: 27,
    textState: "Tocantins",
    mask: ["##########-#", "########-#"],
    placeHolder: "Inscrição Estadual",
    maxLength: 12,
    minLengthClean: 9
  }
]

export const PRE_SELECTED_FILTERS = {
  status_id: [
    {
      searchable: "status_id",
      value: 1,
      name: "Aguardando",
      display_name: "Auditoria",
      type: "awaiting"
    },
    {
      searchable: "status_id",
      value: 3,
      name: "Em Andamento",
      display_name: "Em Andamento",
      type: "in-progress"
    },
    {
      searchable: "status_id",
      value: 4,
      name: "Pendente",
      display_name: "Vendedor",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 5,
      name: "Pendente",
      display_name: "Biometria",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 6,
      name: "Pendente",
      display_name: "BKO",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 7,
      name: "Pendente",
      display_name: "Sistema",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 8,
      name: "Pendente",
      display_name: "Agendamento",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 9,
      name: "Pendente",
      display_name: "Integração",
      type: "pending"
    },
    {
      value: 11,
      searchable: "status_id",
      name: "Pendente",
      display_name: "Aprovação",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 18,
      name: "Pendente",
      display_name: "Cobertura",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 19,
      name: "Pendente",
      display_name: "Crédito",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 22,
      name: "Pendente",
      display_name: "Engenharia",
      type: "pending"
    },
    {
      searchable: "status_id",
      value: 25,
      name: "Pendente",
      display_name: "Aceite do Termo",
      type: "pending",
    }
  ]
}

export const AUDIT_STATUS = [
  {
    id: "category-3",
    type: "finished",
    icon: "check-circle",
    title: "Finalizado",
    substatus: [
      {
        id: 2,
        type: "Finalizado"
      },
      {
        id: 12,
        type: "Cancelado"
      },
      {
        id: 13,
        type: "Desistência"
      },
      {
        id: 26,
        type: "Reprovado",
        indicator: "reproved"
      }
    ]
  },
  {
    id: "category-1",
    type: "pending",
    icon: "alert-triangle",
    title: "Pendente",
    substatus: [
      {
        id: 4,
        type: "Vendedor"
      },
      {
        id: 5,
        type: "Biometria"
      },
      {
        id: 6,
        type: "BKO"
      },
      {
        id: 7,
        type: "Sistema"
      },
      {
        id: 8,
        type: "Agendamento"
      },
      {
        id: 9,
        type: "Integração"
      },
      {
        id: 11,
        type: "Aprovação"
      },
      {
        id: 18,
        type: "Cobertura",
      },
      {
        id: 19,
        type: "Crédito",
      },
      {
        id: 22,
        type: "Engenharia"
      },
      {
        id: 25,
        type: "Aceite do Termo"
      }
    ]
  },
  {
    id: "category-2",
    type: "awaiting",
    icon: "clock",
    title: "Aguardando",
    substatus: [
      {
        id: 1,
        type: "Auditoria"
      },
      {
        id: 10,
        type: "Biometria"
      }
    ]
  },
  {
    id: 3,
    type: "in-progress",
    icon: "settings",
    title: "Em Andamento"
  }
]

export const PROOF_OF_LIFE_STATUS = {
  UNREALIZED: 0,
  APPROVED: 1,
  REPROVED: 2
}

export const INVALID_CELLPHONE_NUMBER = { value: 7 }

export const SERVICES_TYPES = {
  plan: "PLAN",
  serviceAdditional: "SERVICE_ADDITIONAL",
  packaged: "PACKAGED"
}

export const CATEGORY_TYPES = {
  mobile: "Móvel",
  tv: "TV",
}

export const MOVEMENT_TYPES = {
  alta: "Alta",
  upgrade: "Upgrade",
  migration: "Migração",
  downgrade: "Downgrade",
  portability: "Portabilidade"
}

export const PORTABILITY = {
  yes: "Sim",
  no: "Não"
}

export const VALIDATION_MESSAGE = {
  email: {
    isValidEmail: "E-mail inválido. Por favor digite um e-mail válido",
    email: "O e-mail informado é inválido.",
    check_email: "O e-mail informado é inválido."
  },
  cellphone: {
    required:
      "É obrigatório o preenchimento do Telefone Celular ou Telefone Fixo",
    phone: "O número de telefone informado é inválido."
  },
  landline: {
    phone: "O número de telefone informado é inválido."
  },
  anotherContact: {
    unique:
      "Outro Contato deve ser diferente do Telefone Celular ou Telefone Fixo",
    phone: "O número de telefone informado é inválido.",
    required: "É obrigatório o preenchimento do Outro Contato"
  }
}

export const SHIPPING_OPTIONS = [
  { value: 1, name: "Papel", slug: "PAPEL", searchable: "PAPER" },
  { value: 2, name: "E-mail", slug: "EMAIL", searchable: "EMAIL" },
  { value: 3, name: "Entrega Presencial", slug: "PRESENCIAL", searchable: "PRESENCIAL" }
]

export const SHIPPING_WHATSAPP = {
  value: 4,
  name: "Whatsapp",
  slug: "WHATSAPP",
  searchable: "WHATSAPP"
}

export const ALL_SHIPPING_OPTIONS = [
  ...SHIPPING_OPTIONS,
  SHIPPING_WHATSAPP
]

export const BANK_SLIP = {
  value: 1,
  name: "Boleto Bancário",
  slug: "BOLETO",
  searchable: "BANK_SLIP"
}

export const DEBIT = {
  value: 2,
  name: "Débito Automático",
  slug: "DEBITO_AUTOMATICO",
  searchable: "DEBIT"
}

export const DOCUMENT_DOWNLOAD_NAME = {
  selfie: "foto_do_rosto",
  physical_front: "documento_frontal",
  physical_back: "documento_verso",
  digital: "documento_digital"
}

export const DOCUMENT_IMAGE_TYPE = {
  physical_front: "DOCUMENT_FRONT",
  physical_back: "DOCUMENT_BACK",
  digital: "DOCUMENT_FULL",
  selfie: "SELFIE"
}

export const CONTACT_TYPE = {
  CELLPHONE: "CELULAR",
  LANDLINE: "FIXO",
  ALTERNATIVE: "CELULAR_ALTERNATIVO",
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP"
}

export const PAYMENT_TYPE = {
  DEBIT: "DEBITO_AUTOMATICO",
  BILLET: "BOLETO"
}

export const PERSON_TYPE = {
  INDIVIDUAL: "FISICA",
  LEGAL: "JURIDICA"
}

export const ADDRESS_TYPE = {
  COMMERCIAL: "COMERCIAL",
  RESIDENTIAL: "RESIDENCIAL"
}

export const INVOICE = "invoice"

export const SIM_CARD_TYPE_OPTIONS = [
  { value: "3499", text: "eSIM" },
  { value: "3500", text: "SimCard" }
]

export const GENDER_OPTIONS = [
  { text: "Masculino", value: "M" },
  { text: "Feminino", value: "F" },
  { text: "Nenhum", value: "O" }
]

export const STATUS_COVERAGE_ANALYSIS = {
  NOT_REALIZED: 1,
  APPROVED: 2,
  DISAPPROVED: 3,
  CITY_WITHOUT_MAPPING: 4
}

export const MARITAL_STATUS_OPTIONS = [
  { value: 1, text: "Solteiro(a)" },
  { value: 2, text: "Casado(a)" },
  { value: 3, text: "Divorciado(a)" },
  { value: 4, text: "Viúvo(a)" },
  { value: 5, text: "Separado(a)" },
  { value: 6, text: "União Estável" }
]

export const LANDLINE_TYPE_OPTIONS = [
  { text: "Residencial", value: "RESIDENCIAL" },
  { text: "Comercial", value: "COMERCIAL" }
]

export const LANDLINE_PARTICULARITY_OPTIONS = [
  { text: "Pessoal", value: "PESSOAL" },
  { text: "Comercial", value: "COMERCIAL" }
]

export const FILE_TYPES = [
  { name: "Comprovante de Residência", value: "RESIDENCE_PROOF" }
]

export const STATUS_CREDIT_ANALYSIS = {
  NOT_REALIZED: 1,
  APPROVED: 2,
  DISAPPROVED: 3,
  NECESSARY_MANUAL_ANALYSIS: 4
}

export const WALLET_OPTIONS = [
  { text: "Selecione...", value: "" },
  // { text: "Ideia (Tecnet)", value: 3 },
  { text: "Conexão", value: 4 },
  { text: "Outcenter", value: 6 },
  // { text: "Webnet", value: 7 },
  { text: "Starweb", value: 9 },
  { text: "Cabo", value: 12 },
  { text: "Multplay", value: 13 },
  { text: "Webby", value: 14 },
  { text: "Azza", value: 16},
]

export const STATUS_BIOMETRY = {
  1: "Aguardando",
  2: "Aprovado",
  3: "Reprovado",
  4: "Recaptura",
  5: "Falha de Integração",
  6: "Tempo esgotado",
  7: "Recusada",
  8: "Correção Solicitada"
}

export const BADGE_STATUS = {
  PENDING: "pending",
  WAITING: "waiting",
  IN_PROGRESS: "in-progress",
  SUCCESS: "success",
  CANCELED: "error"
}

export const STATUS_LABELS = {
  WAITING: "Aguardando",
  APPROVED: "Aprovado",
  DISAPPROVED: "Reprovado",
  ABANDONED: "Desistência",
  CANCELED: "Cancel"
}

export const DOCUMENT_LENGTH = {
  cpf: 11,
  cnpj: 14
}

export const BIOMETRY_ORIGINS = {
  LINK: "li",
  QR_CODE: "qc"
}

export const MAX_INTERVAL_DAYS = 30

export const SALE_STATUS = {
  waiting: "Aguardando"
}

export const SALE_SUB_STATUS = {
  waiting_payment: "Pagamento"
}

export const BIOMETRY_ORIGIN = {
  1: {
    description: "whatsapp",
    icon: ['fab', 'whatsapp']
  },
  2: {
    description: "link",
    icon: "link"
  },
  3: {
    description: "qrcode",
    icon: "qrcode"
  },
  4: {
    description: "email",
    icon: "envelope"
  }
}

export const BIOMETRY_SIMILARITY_STATUS = {
  GOOD: "good",
  MEDIUM: "medium",
  BAD: "bad"
}

export const BIOMETRY_SIMILARITY_ATTENTION_FACTOR = 0.7

export const BIOMETRY_SIMILARITY_TYPE = {
  PROGRESS_BAR: "progressbar",
  PROGRESS_VALUE: "progressvalue"
}

export const BIOMETRY_FIELD = {
  CPF: "cpf",
  NAME: "nome",
  BIRTHDATE: "nascimento",
  DATE: "data"
}

export const BIOMETRY_ORIGIN_DESCRIPTION = {
  whatsapp: "WhatsApp",
  link: "Link",
  qrcode: "QR Code",
  email: "E-mail"
}

export const STATUS_BIOMETRY_VALUE = {
  WAITING: 1,
  APPROVED: 2,
  ERROR: 3
}

export const AUDIT_ADDRESS_FIELD = Object.freeze({
  POSTCODE: "postcode",
  STREET: "address",
  NUMBER: "number",
  NEIGHBORHOOD: "neighborhood"
})

export const AUDIT_ADDRESS_INPUTS = [
  { key: AUDIT_ADDRESS_FIELD.POSTCODE, label: "CEP" },
  { key: AUDIT_ADDRESS_FIELD.STREET, label: "Endereço" },
  { key: AUDIT_ADDRESS_FIELD.NEIGHBORHOOD, label: "Bairro" },
  { key: AUDIT_ADDRESS_FIELD.NUMBER, label: "Número" }
]

export const MAX_AUDIT_ADDRESS_COMPLEMENTS = 3

export const INSTALLATION_PERIOD_OPTIONS = [
  { text: "Manhã", value: "MANHÃ" },
  { text: "Tarde", value: "TARDE" }
]
